import { useState } from 'react';

function Accordion({ title, children, defaultOpen = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={title === 'Design focus' ? 'py-3 border-t border-[#E5E5E5]' : 'mb-3'}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between text-base font-medium text-[#0D0D0D] mb-2 hover:opacity-80 transition-opacity"
      >
        <span>{title}</span>
        <span className="material-symbols-outlined text-2xl transition-all duration-300">
          {isOpen ? 'expand_less' : 'expand_more'}
        </span>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        {children}
      </div>
    </div>
  );
}

export default Accordion;

